// getHttpProxyHeaders.js
'use strict';
import { legacySSR as legacySSRDebug } from '../resource/debug.js';
import { v4 as uuidv4 } from 'uuid';

const legacySSRLog = legacySSRDebug.extend('log');
const legacySSRError = legacySSRDebug.extend('error');

/**
 * Get http proxy headers
 * @param {object} options
 * @param {object} options.request - fetch request instance.
 * @returns {object} - http proxy headers.
 */
const getHttpProxyHeaders = ({ request = {} } = {}) => {
  const log = legacySSRLog.extend('getHttpProxyHeaders');
  const errorLog = legacySSRError.extend('getHttpProxyHeaders');
  const headers = {};

  try {
    log('start', { request });

    const origin = request.url;
    headers.Origin = origin;

    const httpProxyHeaderKeys =
      process.env.HTTP_PROXY_HEADERS?.toLowerCase()
        .split(',')
        .filter(item => item)
        .map(item => item.trim()) || [];
    httpProxyHeaderKeys.forEach(key => {
      try {
        if (request.headers.get(key)) {
          headers[key] = request.headers.get(key);
        }
      } catch (error) {
        errorLog('read header error', { error, key });
      }
    });

    if (!headers['x-client-id']) {
      // add default cient id to bypass ratelimit.
      headers['x-client-id'] = uuidv4();
    }

    log('result', { headers });
    return headers;
  } catch (error) {
    errorLog('error', { error });
    return {};
  }
};

export default getHttpProxyHeaders;
